function animateCartFloatingBubbleIncrease(cartFloatingBubble, increaseAmount) {
    if (!cartFloatingBubble || increaseAmount <= 0) return;

    const plusTag = document.createElement('span');
    plusTag.className = 'cart-floating-bubble__plus-rise';
    plusTag.textContent = `+${increaseAmount}`;
    cartFloatingBubble.appendChild(plusTag);

    plusTag.addEventListener('animationend', () => {
      plusTag.remove();
    }, { once: true });
  }

  function animateCartFloatingBubbleReceive(cartFloatingBubble) {
    if (!cartFloatingBubble) return;

    cartFloatingBubble.classList.remove('cart-floating-bubble--receiving');
    void cartFloatingBubble.offsetWidth;
    cartFloatingBubble.classList.add('cart-floating-bubble--receiving');

    cartFloatingBubble.addEventListener('animationend', function handleReceiveAnimationEnd(event) {
      if (event.animationName === 'cart-bubble-receive') {
        cartFloatingBubble.classList.remove('cart-floating-bubble--receiving');
      }
    }, { once: true });
  }